import { Box, BoxProps, Flex } from '@wegroup/design-system';
import React from 'react';
import { chakraCustomScrollBar } from '../../../../../../../common/src/utils/styledComponentsUtils';

interface Props {
  outerWrapperProps?: BoxProps;
}

const CompanyScanContentWrapper: React.FC<
  React.PropsWithChildren<Props & BoxProps>
> = ({ children, outerWrapperProps, ...props }) => {
  return (
    <Box
      position="relative"
      overflowY="auto"
      flexGrow={1}
      py="8"
      px="6"
      sx={chakraCustomScrollBar}
      {...outerWrapperProps}
    >
      <Flex maxW="150.4rem" margin="0 auto" {...props}>
        {children}
      </Flex>
    </Box>
  );
};

export default CompanyScanContentWrapper;
